import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './alert.component';
import { WmTransitionModule } from '../transition/index';
import { WmIconModule } from '../icon/index';

@NgModule({
	declarations: [AlertComponent],
	imports: [CommonModule, WmTransitionModule, WmIconModule],
	exports: [AlertComponent]
})
export class WmAlertModule {}
